export default class ImageLoader {

	// Preload a specific question image. By the time a user reaches a question, the pre-loaded question can be instantly shown.
	static preload(questionNumber: number): void {

		// Simply creating a new image with the right source is enough for the image to be pre-loaded.
		const image = new Image();
		image.src = `https://monet-prtl-co.imgix.net/Shared/PersonalityTest/questions/${questionNumber}.jpg`;
	}
}
